/* ============================================================
   ASI8 — hareket katmani

   Horizon surumune gore sayfa ya pencerede ya da .page-wrapper
   icinde kayar. IKISINI DE VARSAY — hangisinin kaydigini tahmin
   etme. Bu yuzden:
     - scroll dinleyicisi document'a CAPTURE fazinda bagli; scroll
       olayi kabarmaz ama yakalama fazinda her elemandan gecer,
       dolayisiyla hangisi kayarsa kaysin haberimiz olur
     - konum olcumu her zaman getBoundingClientRect ile
     - kaydirma miktarina (scrollTop) hic bakilmiyor
     - IntersectionObserver root = viewport, container'dan etkilenmiyor

   > 2026-08-13 hatasi: eski surum .page-wrapper.scrollTop'a bakiyordu.
   > Bu surumde .page-wrapper artik kaymiyor, scrollTop hep 0 kaliyordu,
   > `y === lastY` kapisi da her seyi durduruyordu. Sonuc: ana sayfada
   > asagi kayinca ust menu beyaz kalip gorunmez oluyordu. Bir daha
   > olmasin diye artik hicbir yerde scrollTop okunmuyor.

   Iki kere yuklenirse kendini iptal eder.
   ============================================================ */
(function () {
  if (window.__asi8Kit) return;
  window.__asi8Kit = true;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1. Kelime kelime baslik ----------
     data-words tasiyan baslikleri kelimelere boler. Her kelime kendi
     maskesinin icinden yukari kayar. Erisilebilirlik icin aria-label birakilir. */
  function splitWords(root) {
    (root || document).querySelectorAll('[data-words]:not([data-split])').forEach(function (el) {
      el.setAttribute('data-split', '');
      var text = el.textContent.trim();
      if (!text) return;
      el.setAttribute('aria-label', text);
      var frag = document.createDocumentFragment();
      var wrap = document.createElement('span');
      wrap.className = 'a8-words';
      wrap.setAttribute('aria-hidden', 'true');
      text.split(/\s+/).forEach(function (word, i) {
        var w = document.createElement('span');
        w.className = 'w';
        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.transitionDelay = (0.045 * i) + 's';
        w.appendChild(inner);
        wrap.appendChild(w);
        wrap.appendChild(document.createTextNode(' '));
      });
      frag.appendChild(wrap);
      el.textContent = '';
      el.appendChild(frag);
    });
  }

  /* ---------- 2. SVG cizgi uzunlugu ----------
     stroke-dasharray'i her yolun kendi uzunluguna esitler, yoksa
     farkli boyuttaki sekiller farkli hizda cizilir. */
  function measureStrokes(root) {
    (root || document).querySelectorAll('.a8-facet :is(path, line, circle):not([data-len])').forEach(function (p) {
      p.setAttribute('data-len', '');
      var len = 0;
      try { len = p.getTotalLength(); } catch (e) { len = 600; }
      p.style.setProperty('--len', Math.ceil(len));
    });
  }

  /* ---------- 3. Gorunuse girince ac ---------- */
  var io = null;
  function observe(root) {
    if (!('IntersectionObserver' in window)) {
      (root || document).querySelectorAll('.a8-reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
    }
    (root || document).querySelectorAll('.a8-reveal:not(.is-in)').forEach(function (el) {
      // Ilk ekranda zaten gorunuyorsa beklemeden ac.
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* ---------- 4. Paralaks ----------
     data-parallax="0.18" — elemanin viewport'taki konumuna gore kayar.
     Scroll olayinda dogrudan yazilir; rAF kapisi arkasinda degil, cunku
     sekme arka plana dusunce rAF durur ve eleman donar. */
  var pxNodes = [];
  function collectParallax(root) {
    pxNodes = [].slice.call(document.querySelectorAll('[data-parallax]'));
  }
  function paintParallax() {
    if (reduce.matches) return;
    var vh = innerHeight;
    for (var i = 0; i < pxNodes.length; i++) {
      var el = pxNodes[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var amt = parseFloat(el.dataset.parallax) || 0.15;
      // -1 .. 1 arasi normalize edilmis merkez uzakligi
      var p = ((r.top + r.height / 2) - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * amt * 100).toFixed(2) + 'px,0)';
    }
  }

  /* ---------- 5. Ilerleme cubugu ----------
     data-progress-of="#id" — hedef bolumun ne kadarini gectigini yazar. */
  var prNodes = [];
  function collectProgress() {
    prNodes = [].slice.call(document.querySelectorAll('[data-progress-of]'));
  }
  function paintProgress() {
    for (var i = 0; i < prNodes.length; i++) {
      var el = prNodes[i];
      var target = document.querySelector(el.dataset.progressOf);
      if (!target) continue;
      var r = target.getBoundingClientRect();
      var total = r.height - innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      el.style.setProperty('--p', p.toFixed(4));
    }
  }


  /* ---------- 6. Imlece tepki veren 3B egim ----------
     .a8-tilt tasiyan elemana --rx / --ry yazar. Isaretleyicisi olmayan
     cihazlarda ve reduced-motion'da hic baglanmaz. */
  function bindTilt(root) {
    if (!matchMedia('(hover: hover)').matches || reduce.matches) return;
    (root || document).querySelectorAll('.a8-tilt:not([data-tilt])').forEach(function (el) {
      el.setAttribute('data-tilt', '');
      var max = parseFloat(el.dataset.tiltMax) || 7;
      var scene = el.closest('[data-tilt-scene]') || el;

      scene.addEventListener('pointermove', function (e) {
        var r = scene.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.classList.add('is-live');
        el.style.setProperty('--ry', (px * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (-py * max * 2).toFixed(2) + 'deg');
      }, { passive: true });

      scene.addEventListener('pointerleave', function () {
        el.classList.remove('is-live');
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
      }, { passive: true });
    });
  }

  /* ---------- 7. Kart egimi ----------
     Her kart kendi merkezine gore egilir; ayri ayri dinleyici yerine
     tek delege ile, cok kartli izgaralarda ucuz kalsin diye. */
  function bindCards(root) {
    if (!matchMedia('(hover: hover)').matches || reduce.matches) return;
    (root || document).querySelectorAll('.a8card:not([data-tilt])').forEach(function (card) {
      card.setAttribute('data-tilt', '');
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--cry', (px * 9).toFixed(2) + 'deg');
        card.style.setProperty('--crx', (-py * 7).toFixed(2) + 'deg');
      }, { passive: true });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--cry', '0deg');
        card.style.setProperty('--crx', '0deg');
      }, { passive: true });
    });
  }

  /* ---------- 8. Seffaf ustbilgi + tasin kaydirmayla donusu ----------
     Hero header'in altindan cikana kadar ust yigin acik renk kalir. */
  var hero = null, gems = [];

  /* Sinif HEM <html> HEM <body> uzerine yaziliyor.
     > 2026-08-13: Horizon sayfa yuklendikten sonra `body.className`'i
     > bastan yaziyor ve bizim sinifimizi siliyor. Sonuc: hero'nun
     > uzerindeyken logo ve menu koyu kalip videonun icinde kayboluyordu.
     > <html> uzerindeki kopya bunu kurtariyor; CSS `.a8-hero-top` diye
     > secildigi icin hangisi hayatta kalirsa o calisir. */
  var heroTopWanted = false;
  function applyHeroTop() {
    var de = document.documentElement, b = document.body;
    // Once oku sonra yaz: gereksiz mutasyon MutationObserver'i sonsuz
    // donguye sokar.
    if (de.classList.contains('a8-hero-top') !== heroTopWanted) {
      de.classList.toggle('a8-hero-top', heroTopWanted);
    }
    if (b && b.classList.contains('a8-hero-top') !== heroTopWanted) {
      b.classList.toggle('a8-hero-top', heroTopWanted);
    }
  }
  function setHeroTop(on) {
    heroTopWanted = on;
    applyHeroTop();
  }
  /* Baska bir betik (tema, onizleme cubugu, hot reload) class niteligini
     komple yeniden yazip bizimkini siliyor. Silinirse geri koy. */
  function guardHeroTop() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(applyHeroTop);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* Ilk DEGIL, ilk GORUNUR aday.
     > 2026-08-15: ana sayfada iki hero var — masaustu videosu
     > (asi8-hero-slider) ve mobil fotograf paneli (asi8-hero-mobile).
     > Hangisi calisiyorsa digeri display:none, ama ikisi de DOM'da.
     > Duz querySelector gizli olani secince header koyu kaliyordu:
     > gizli elemanin getBoundingClientRect'i sifir doner, "hero
     > header'in altinda" testi hep false cikar. */
  function visibleHero() {
    var cands = document.querySelectorAll('[data-a8-hero], [data-a8-overlap]');
    for (var i = 0; i < cands.length; i++) {
      if (cands[i].getClientRects().length) return cands[i];
    }
    return null;
  }
  function collectHero() {
    hero = visibleHero();
    gems = [].slice.call(document.querySelectorAll('.a8gem__spin'));
    // Hero yoksa sinif hic kalmasin — yoksa ic sayfalarda menu beyaz kalir.
    if (!hero) setHeroTop(false);
  }
  function paintHero() {
    if (hero && (!document.contains(hero) || !hero.getClientRects().length)) {
      // Kirilma noktasi degismis olabilir; obur hero devralmis midir?
      hero = visibleHero();
      if (!hero) setHeroTop(false);
    }
    if (hero) {
      var r = hero.getBoundingClientRect();
      var head = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 90;
      setHeroTop(r.bottom > head + 10);
    }
    for (var i = 0; i < gems.length; i++) {
      var g = gems[i];
      var gr = g.getBoundingClientRect();
      if (gr.bottom < -300 || gr.top > innerHeight + 300) continue;
      // Kaydirma tasi kendi ekseninde cevirir; surekli donusun uzerine biner.
      var p = ((gr.top + gr.height / 2) - innerHeight / 2) / innerHeight;
      g.style.setProperty('--gy', (p * 120).toFixed(2) + 'deg');
    }
  }

  /* Tek bir rAF kapisi. Kaydirma miktarina bakmadan, her karede en fazla
     bir kere boyar. Olcumler getBoundingClientRect ile oldugu icin hangi
     elemanin kaydigi onemli degil. */
  var queued = false;
  function paintAll() {
    queued = false;
    paintParallax();
    paintProgress();
    paintHero();
  }
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(paintAll);
  }

  function refresh(root) {
    splitWords(root);
    measureStrokes(root);
    observe(root);
    collectParallax();
    collectProgress();
    collectHero();
    bindTilt(root);
    bindCards(root);
    paintAll();
  }

  function bind() {
    guardHeroTop();
    refresh(document);
    // Capture fazi: scroll olayi kabarmaz, ama yakalama fazinda kokten
    // hedefe iner. Pencere de kaysa, .page-wrapper de kaysa yakalanir.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { refresh(document); }, { passive: true });
    addEventListener('load', function () { refresh(document); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) paintAll(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Tema editorunde bolum yeniden yuklendiginde
  document.addEventListener('shopify:section:load', function (e) { refresh(e.target); });
  document.addEventListener('shopify:section:unload', function () { collectParallax(); collectProgress(); });

  window.asi8Refresh = refresh;
})();
